import { getIn } from 'utils';

import { utils } from '../';

function isFormDisabledSetterHandler({ setIsFormDisabled }) {
  return (data) => {
    const value = getIn('meta.isDisabled')(data);
    if (value != null) setIsFormDisabled(value);
    return data;
  };
}

function legalNameEditableSetterHandler({ setLegalNameEditable }) {
  return (data) => {
    const value = getIn('meta.legalNameEditable')(data);
    if (value != null) setLegalNameEditable(value);
    return data;
  };
}

function mergeInitialValuesHandler({ setInitialValues, isFormDisabledSetter, legalNameEditableSetter }) {
  return (data) => {
    isFormDisabledSetter(data);
    legalNameEditableSetter(data);
    setInitialValues(utils.setDefaultInitialValues(data));
  };
}

function onSubmitHandler({ updateApplicationFourthStep }) {
  return (values, form) => updateApplicationFourthStep(utils.valuesSubmitPreparation(values), form);
}

export {
  mergeInitialValuesHandler as mergeInitialValues,
  onSubmitHandler as onSubmit,
  isFormDisabledSetterHandler as isFormDisabledSetter,
  legalNameEditableSetterHandler as legalNameEditableSetter,
};
